export default __webpack_public_path__ + "static/media/archgb.33d6be88.png";